import React, { Component } from 'react';
import ReactDOM from 'react-dom';
import './Components.css';
import myphoto from './icons/myphoto.jpg';


class Contacts extends Component {
    constructor(props){
        super(props);
    }
    render() { 
        return ( 
            <section id="contacts">
                <div className="contacts text-center">
                    <div className="contact-img pt-3">
                        <img className="rounded-circle" 
                           src={myphoto} 
                           alt="my-photo" 
                           style={{width:'200px'}}
                        />
                        <h1 className="text-center pt-3">PHANINDRA</h1>
                    </div>

                    <div className="container">
                        <div className="row jsutify-content-center">
                            <div className="col">
                                <a href="https://www.facebook.com/maram.phanindrareddy" target="_blank" >
                                    <li className="fa fa-facebook"></li>
                                </a>
                                <a href="https://github.com/Phanindra-Reddy/" target="_blank" >
                                    <li className="fa fa-github"></li>
                                </a>
                                <a href="https://www.linkedin.com/in/phanindrareddy-maram/747973145" target="_blank" >
                                    <li className="fa fa-linkedin"></li>
                                </a>
                                <a href="mailto:mpr4070@gmail.com" target="_blank" >
                                    <li className="fa fa-envelope"></li>
                                </a>
                                <a href="https://www.snapchat.com/add/mpr4070" target="_blank" >
                                    <li className="fa fa-snapchat-ghost"></li>
                                </a>
                            </div>
                        </div>
                    </div>

        
                </div>

            </section>
         );
    }
}
 
export default Contacts;